export default {
    getList: {
        /*假设  
            0: 未分析 -- 可分析
            1: 已分析 -- 可查看
            2: 分析失败 -- 可重试
            3: 分析中 -- 不可操作
        */
        default: [{
            status: 1,
            time_upload: 1111111111000,
            type_database: "ORACLE",
            name: 'orcl-his-rac1',
            remarks: 'HIS系统巡检分析',
            opration: '未分析'
        }, {
            status: 2,
            time_upload: 2222222222000,
            type_database: "ORACLE",
            name: 'orcl-pacs',
            remarks: 'PACS系统巡检分析',
        }, {
            status: 3,
            time_upload: 3333333333000,
            type_database: "ORACLE",
            name: 'orcl-lis',
            remarks: 'LIS系统巡检分析',
        },
        {
            status: 0,
            time_upload: 1112222111000,
            type_database: "ORACLE",
            name: 'orcl-his-rac2',
            remarks: 'HIS系统巡检分析',
            opration: '未分析'
        },]
    }
}